import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showAdd: false,
    isEdit:false,
    dateFrom:new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 10),
    dateTo: null,
    checkTo:false,

  },

  mutations: {
    
    setShowAdd(state, data) {
      state.showAdd = data
    },
    setIsEdit(state, data) {
      state.isEdit = data
    },
    setDateTo(state,data){
      state.dateTo=data
    },
    setDateFrom(state,data){
      state.dateFrom=data
    },
    setCheckTo(state,data){
      state.checkTo=data
    },

   
   
  },
  actions: {
  
  },
});
